import {axios, abortController} from '../../../config/axios-config'

const getVersaoAtual = async () => {
    try {
        let response = null
        response = await axios.get('/getVersaoAtual', {cancelToken: abortController.token, timeout: 60000})
        return response.data
    } catch (error) {
        console.log(error)
    }
}
export default getVersaoAtual